// extracted by mini-css-extract-plugin
module.exports = {"noResultsContainer":"SCNoResults-module__noResultsContainer","noSearchResult":"SCNoResults-module__noSearchResult"};